module.exports = __webpack_public_path__ + "static/Youtravelme-ae6a1de7cc42de587f8ccb8492abf182.png";